<template>
    <a
        :href="data.url"
        class="rounded-lg bg-white box-shadow overflow-hidden card"
        target="_blank"
    >
        <div class="p-3 bg-white">
            <div class="d-inline-flex position-relative mb-2">
                <div class="position-relative">
                    <span
                        class="
                            d-flex
                            align-items-center
                            justify-content-center
                            text-small
                            text-white
                            rounded-circle
                            bg-primary
                            status
                        "
                        :content="$t('general.kanban_filters.' + data.status)"
                        v-tippy
                    >
                        <ui-icon :icon="getStatusIcon(data.status)" />
                    </span>

                    <ui-avatar
                        :name="data.name"
                    />
                </div>

                <div class="ml-3">
                    <h4 class="mb-0">
                        {{ data.name }}
                    </h4>
                    <span
                        v-text="data.patient_number"
                        class="text-smaller"
                    />
                </div>
            </div>



            <ul class="d-flex flex-column align-items-start mt-3 text-small list">
                <li class="d-inline-flex align-items-center">
                    <strong class="mr-1">
                        {{ $t('general.last_activity') }}:
                    </strong>
                    <span v-if="data.last_activity">
                        {{ data.last_activity | dateAgo }}
                    </span>
                    <span v-else>
                        -
                    </span>
                </li>
                <li class="d-inline-flex align-items-center">
                    <strong class="mr-1">
                        {{ $t('general.last_edited') }}:
                    </strong>
                    <span
                        v-if="data.last_edited.date && data.last_edited.name"
                        :content="data.last_edited.name"
                        v-tippy
                    >
                        {{ data.last_edited.date | dateFormat }}
                    </span>
                    <span v-else>
                        -
                    </span>
                </li>
                <li class="d-inline-flex align-items-center">
                    <strong class="mr-1">
                        {{ $tc('messages.unread_messages', 2) }}:
                    </strong>
                    {{ data.unread_messages }}
                </li>
            </ul>
        </div>
        <div
            v-for="lifestyleModule in data.module"
            :key="lifestyleModule.id"
            class="d-flex align-items-center p-3 bg-info module-score-card"
        >
            <div>
                <div
                    :style="{ backgroundColor: getStatusColor(lifestyleModule.trend) }"
                    class="mb-2 module-color"
                />

                <h4 class="mb-1 text-smaller">
                    {{ lifestyleModule.name }}
                </h4>
            </div>

            <span class="d-flex ml-auto align-items-center mt-1 text-black-50 trend">
                <p class="ml-2 text-smallest font-weight-normal">
                    {{ $t(`general.trend.${lifestyleModule.trend}_short`) }}
                </p>
            </span>
        </div>
    </a>
</template>

<script>
    import UiAvatar from '../ui/avatar';
    import UiIcon from '../ui/icon.vue';

    export default {
        name: 'KanbanCard',
        components: {
            UiAvatar,
            UiIcon,
        },
        props: {
            data: {
                type: Object,
                default: () => {},
            },
        },
        data: () => ({
            hospital: window.Laravel.hospital,
        }),
        methods: {
            getStatusIcon(status) {
                switch (status) {
                    case 'coach_pregnant':
                        return 'add';
                    case 'coach_started':
                        return 'play';
                    case 'coach_not_started':
                        return 'pause';
                    case 'coach_quit':
                        return 'stop';
                    default:
                        return 'stop';
                }
            },

            getStatusColor(trend) {
                switch (trend) {
                    case 'up':
                        return '#54A254';
                    case 'down':
                        return '#B14F57';
                    default:
                        return '#F5CB46';
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .card {
        color: $dark;
        transition: 0.3s;

        &:hover {
            transform: translateY(-2px);
        }
    }

    .module {
        &-color {
            width: 32px;
            height: 6px;
            border-radius: 10px;
        }

        &-score-card {
            &:not(:last-of-type) {
                border-bottom: 1px solid rgba($dark, 0.15);
            }
        }
    }

    .list {
        line-height: 24px;
    }

    .status {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        width: 14px;
        height: 14px;
    }
</style>
